import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
  { href: "#process", label: "Process" },
  { href: "#about", label: "About" },
  { href: "#founder", label: "Founder" },
  { href: "#fees", label: "Fees" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color] duration-500 border-b ${
        scrolled || open ? "bg-ivory/90 backdrop-blur-md border-hairline" : "bg-transparent border-transparent"
      }`}
    >
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-6 md:px-12">
        <a href="#top" data-testid="header-logo-link" aria-label="S & H Automotive Acquisition Group – home">
          <img src="/logo.svg" alt="S & H | Automotive Acquisition Group" className="h-11 w-auto md:h-16" />
        </a>
        <nav className="hidden items-center gap-10 md:flex">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} data-testid={`nav-${l.label.toLowerCase()}`} className="link-line pb-1 text-sm text-stone hover:text-ink transition-colors duration-300">
              {l.label}
            </a>
          ))}
          <a href="#contact" data-testid="nav-contact-cta" className="border border-ink px-6 py-2.5 text-xs uppercase tracking-[0.22em] hover:bg-ink hover:text-ivory transition-colors duration-500">
            Begin a request
          </a>
        </nav>
        <button type="button" data-testid="mobile-menu-toggle" aria-label="Toggle menu" className="md:hidden p-2" onClick={() => setOpen((o) => !o)}>
          {open ? <X className="h-5 w-5" strokeWidth={1.25} /> : <Menu className="h-5 w-5" strokeWidth={1.25} />}
        </button>
      </div>
      {open && (
        <nav data-testid="mobile-menu" className="md:hidden border-t border-hairline px-6 pb-8 pt-4 flex flex-col gap-5">
          {[...LINKS, { href: "#contact", label: "Contact" }].map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} data-testid={`mobile-nav-${l.label.toLowerCase()}`} className="font-display text-2xl">
              {l.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
};
